<template>
  <div class="hide-address-field form-check">
    <input id="hidden-address" type="checkbox" class="form-check-input" :checked="hiddenAddress" @change="setHideAddress($event.target.checked)">
    <label class="form-check-label" for="hidden-address">
      {{ i18n.t('events.form.hide_address') }}
    </label>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters(['hiddenAddress'])
  },

  methods: {
    ...mapMutations(['setValue']),
    setHideAddress(value) {
      this.setValue({field: 'hiddenAddress', value: value})
    }
  }
}
</script>
